exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-body .body-container img{width:80%!important;height:auto}.post-body{width:75%;margin:30px auto;padding:60px;text-align:left}.top{margin-bottom:70px}.post-body .top h2{font-size:44px;font-family:adobe-caslon-pro,serif;font-weight:700;font-style:italic}.post-one-container p{font-size:20px;font-family:brandon-grotesque,sans-serif;font-weight:400;font-style:normal}.post-image img{width:100%}.credits p{font-size:90%}.credits a{color:#666!important}ul.blog-list{display:flex!important;flex-direction:column;list-style-type:disc!important}.body-container img{width:100%!important;height:auto}@media (max-width:775px){.post-body{padding:20px;margin-bottom:-60px}.post-body .center{flex-direction:column}.post-body .body-container img{width:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-416e9fc4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/BlogPost.vue
// module id = 157
// module chunks = 0